import * as React from 'react';
import { IActivityItemNameProps } from './types';
import './_ActivityItemName.scss';
import { CLASS_ACTIVITY_ITEM } from '../constants';
import { escape } from 'underscore';
import { Tooltip } from 'kui';
import { getAsidePanelTooltip } from '../../../../../asidePanel/helpers/getAsidePanelTooltip';
import ReactHtmlParser from 'react-html-parser';
import { clearMarkdown } from '../../../../../../base/helpers/clearMarkdownHelper';
import { GOOGLE_SPACING } from '../../../../../../../../const';
import { ACTIVITY_NAME_MAX_SYMBOLS_LENGTH, ACTIVITY_NAME_MIN_WIDTH, ACTIVITY_NAME_STEP } from './constants';

export function ActivityItemName({
    icon,
    isMarkdown,
    isRemove,
    name,
    tooltip,
    style,
    onClick
}: IActivityItemNameProps) {
    const className = CLASS_ACTIVITY_ITEM + '__name';
    const classNameTooltip = className + '--tooltip'
    const length = escape(name).length;
    const symbolsCount = length < ACTIVITY_NAME_MAX_SYMBOLS_LENGTH ? length : ACTIVITY_NAME_MAX_SYMBOLS_LENGTH;
    let minWidth = symbolsCount * ACTIVITY_NAME_STEP + (icon ? GOOGLE_SPACING * 3 : 0);
    if (minWidth < ACTIVITY_NAME_MIN_WIDTH) {
        minWidth = ACTIVITY_NAME_MIN_WIDTH;
    }
    return <Tooltip {...getAsidePanelTooltip({
                value: escape(clearMarkdown(tooltip || name)),
                className: classNameTooltip,
                direction: 'up-right'}
            )
        }>
        <div
            className={`${className} ${isRemove ? className + '--remove' : ''}`}
            style={{
                minWidth,
                ...style
            }}
            onClick={onClick}
        >
            {icon}
            <div className={className + '-text'}>{ReactHtmlParser(isMarkdown ? name : escape(name))}</div>
        </div>
    </Tooltip>;
}
